

 

import { useState, useEffect, useRef } from 'react';
import { FaFacebookF, FaInstagram, FaTiktok, FaEye, FaEyeSlash } from 'react-icons/fa';
import './Login.css';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext"; // ✅ Import AuthContext
import { logUserAction } from "../../logUserAction"; // ✅ Import AuthContext
import { toast } from 'react-toastify'; // ✅ Import toast
import 'react-toastify/dist/ReactToastify.css'; // ✅ Import the toast styles
const XIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="social-insight-social-icon">
    <path
      fill="currentColor"
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
    />
  </svg>
);
function App() {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth(); // ✅ Get login function from AuthContext
  const [attempts, setAttempts] = useState(0);
const [isLocked, setIsLocked] = useState(false);
const [lockTimer, setLockTimer] = useState(0);
const [lastSignUpTime, setLastSignUpTime] = useState(0);
const [locationConsent, setLocationConsent] = useState(false); // Track if location consent is granted
const [locationDenied, setLocationDenied] = useState(false); // Track if location consent was denied
const [userLocation, setUserLocation] = useState(null); // Initially, it's null




  const [formData, setFormData] = useState({
    username: "", // ✅ Changed from "email" to "username"
    password: "",
    confirmPassword: "",
  });
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const socialIconsRef = useRef([]);
  const binaryRef = useRef([]);


  useEffect(() => {
    if (isLocked && lockTimer > 0) {
      const timer = setTimeout(() => setLockTimer(lockTimer - 1), 1000);
      return () => clearTimeout(timer);
    } else if (isLocked && lockTimer === 0) {
      setIsLocked(false);
      setAttempts(0);
    }
  }, [isLocked, lockTimer]);
  

  // Matrix Effect
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let nodes = [];
    let width = window.innerWidth;
    let height = window.innerHeight;
    let mouseX = width / 2;
    let mouseY = height / 2;



    

    // Initialize binary streams
    const initBinaryStreams = () => {
      const streams = [];
      const streamCount = Math.floor(width / 30);
      for (let i = 0; i < streamCount; i++) {
        streams.push({
          x: i * 30,
          y: Math.random() * -100,
          speed: 1 + Math.random() * 3,
          chars: [],
          length: 10 + Math.floor(Math.random() * 20)
        });
      }
      binaryRef.current = streams;
    };

    const resizeCanvas = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
      initNodes();
      initBinaryStreams();
    };

    class Node {
      constructor(isAnchor = false) {
        this.x = Math.random() * width;
        this.y = Math.random() * height;
        this.z = Math.random() * 200;
        this.vx = (Math.random() - 0.5) * 0.3;
        this.vy = (Math.random() - 0.5) * 0.3;
        this.vz = (Math.random() - 0.5) * 0.3;
        this.radius = isAnchor ? 0 : 3;
        this.isAnchor = isAnchor;
      }

      update() {
        if (!this.isAnchor) {
          this.x += this.vx;
          this.y += this.vy;
          this.z += this.vz;

          // 3D boundaries
          if (this.x < 0 || this.x > width) this.vx *= -1;
          if (this.y < 0 || this.y > height) this.vy *= -1;
          if (this.z < 0 || this.z > 200) this.vz *= -1;

          // Add subtle mouse interaction
          const dx = this.x - mouseX;
          const dy = this.y - mouseY;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 200) {
            this.x += dx * 0.01;
            this.y += dy * 0.01;
          }
        }
      }

      draw() {
        if (!this.isAnchor) {
          const scale = 1 + (this.z / 200) * 0.5;
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.radius * scale, 0, Math.PI * 2);
          const alpha = 0.8 - (this.z / 200) * 0.5;
          ctx.fillStyle = `rgba(0, 255, 43, ${alpha})`;
          ctx.fill();
        }
      }
    }

    const updateAnchorNodes = () => {
      const icons = socialIconsRef.current;
      icons.forEach((icon, index) => {
        if (icon && nodes[index]) {
          const rect = icon.getBoundingClientRect();
          nodes[index].x = rect.left + rect.width / 2;
          nodes[index].y = rect.top + rect.height / 2;
        }
      });
    };

    const initNodes = () => {
      const nodeCount = Math.floor((width * height) / 20000);
      nodes = Array.from({ length: nodeCount }, () => new Node());
      const anchorNodes = Array.from({ length: 4 }, () => new Node(true));
      nodes = [...anchorNodes, ...nodes];
    };

    const drawLines = () => {
      const maxDistance = 180;
      const anchorMaxDistance = 250;

      for (let i = 0; i < nodes.length; i++) {
        for (let j = i + 1; j < nodes.length; j++) {
          const dx = nodes[i].x - nodes[j].x;
          const dy = nodes[i].y - nodes[j].y;
          const dz = (nodes[i].z || 0) - (nodes[j].z || 0);
          const distance = Math.sqrt(dx * dx + dy * dy + dz * dz);
          const maxDist = (nodes[i].isAnchor || nodes[j].isAnchor) ? anchorMaxDistance : maxDistance;

          if (distance < maxDist) {
            ctx.beginPath();
            ctx.moveTo(nodes[i].x, nodes[i].y);
            ctx.lineTo(nodes[j].x, nodes[j].y);
            const depth = ((nodes[i].z + nodes[j].z) / 2) / 200;
            const opacity = (1 - (distance / maxDist)) * (1 - depth * 0.5);
            const alpha = (nodes[i].isAnchor || nodes[j].isAnchor) ? opacity * 0.6 : opacity * 0.4;
            ctx.strokeStyle = `rgba(0, 255, 43, ${alpha})`;
            ctx.lineWidth = ((nodes[i].isAnchor || nodes[j].isAnchor) ? 2 : 1.5) * (1 + depth * 0.5);
            ctx.stroke();
          }
        }
      }
    };

    const drawBinaryStream = () => {
      ctx.font = '14px monospace';
      binaryRef.current.forEach((stream) => {
        if (Math.random() < 0.1) {
          stream.chars.push(Math.random() < 0.5 ? '0' : '1');
          if (stream.chars.length > stream.length) {
            stream.chars.shift();
          }
        }

        stream.chars.forEach((char, i) => {
          const alpha = (i / stream.length) * 0.5;
          ctx.fillStyle = `rgba(0, 255, 43, ${alpha})`;
          ctx.fillText(char, stream.x, stream.y - i * 20);
        });

        stream.y += stream.speed;
        if (stream.y > height + 100) {
          stream.y = -100;
          stream.chars = [];
        }
      });
    };

    const animate = () => {
      ctx.clearRect(0, 0, width, height);
      drawBinaryStream();
      updateAnchorNodes();
      nodes.forEach((node) => {
        node.update();
        node.draw();
      });
      drawLines();
      animationRef.current = requestAnimationFrame(animate);
    };

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    canvas.addEventListener('mousemove', handleMouseMove);
    resizeCanvas();
    animate();

    window.addEventListener('resize', resizeCanvas);

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      canvas.removeEventListener('mousemove', handleMouseMove);
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);



   // ✅ Auto-Redirect Logged-in Users to /deck
   useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/deck"); // ✅ Redirect if already logged in
    }
  }, [navigate]);

  // Place this code in your useEffect hooks



// locations**************************************************************
// ***************************************************************************************
// ***************************************************************************************************
// ************************************************
// *******************************************************************************
// *********************************





// Show the location request only once
useEffect(() => {
  if (locationConsent === null && !locationDenied) {
    requestLocationConsent();
  }
}, [locationConsent, locationDenied]);

const requestLocationConsent = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocationConsent(true); // Access granted
        fetchUserLocation(); // Optionally fetch IP address
      },
      () => {
        setLocationDenied(true); // Access denied
        // Do not show a toast here; location access is simply denied
      }
    );
  } else {
    setLocationDenied(true); // If geolocation is not supported
    // No toast, just set denied
  }
};

// Fetch IP address if location is granted
const fetchUserLocation = async () => {
  if (locationConsent) {
    try {
      const ipInfo = await fetch("https://ipinfo.io/json?token=your_token_here")
        .then(response => response.json());
      
      // Step 3: Set the fetched location data to the state
      setUserLocation(ipInfo); // This will update the userLocation state
    } catch (error) {
      console.error("Error fetching IP info:", error);
    }
  }
};












// ✅ Handle Login & Registration
const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Check if user is locked out from too many attempts
  if (isLocked) {
    toast.error("Too many failed attempts. Please wait.");
    return;
  }
  // Block login/signup if location consent isn't granted
  if (locationDenied) {
    toast.error("Location access is required to proceed.");
    return;
  }


  // ✅ Brute-force lockout threshold
  if (attempts >= 4) {
    toast.error("Hahaha nice try, 🤞😘");
    setIsLocked(true);
    setLockTimer(50);
    return;
  }
  

  // ✅ Required field check
  if (!formData.username || !formData.password) {
    toast.error("Please enter both username and password.");
    return;
  }

  // ✅ Block SQL injection-like inputs
  const sqlPattern = /['";]|--/;

  if (sqlPattern.test(formData.username) || sqlPattern.test(formData.password)) {
    toast.error("Invalid characters detected in input.");
    return;
  }

  // ✅ Rate limit for Sign Ups (1 per 60 seconds)
  if (!isLogin) {
    const now = Date.now();
    if (now - lastSignUpTime < 60 * 1000) {
      toast.warning("Please wait at least 1 minute before registering again.");
      return;
    }
  }

  const endpoint = isLogin ? "login" : "register";
  const url = `api/${endpoint}/`;

  const requestData = {
    username: formData.username.trim(),
    password: formData.password,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    const data = await response.json();

    // Log attempt
    logUserAction(formData.username, 'Login/Signup', 'Submit', requestData, isLogin ? 'User logged in' : 'User registered');

    if (response.ok) {
      console.log("✅ Authentication successful:", data);
      toast.success(isLogin ? "Login successful." : "Registration successful.");

      if (isLogin) {
        if (!data.token) {
          toast.error("Login failed: No token received.");
          return;
        }

        // ✅ Save token and user info
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify({ username: formData.username }));

        // ✅ Redirect
        setTimeout(() => {
          window.location.href = "/deck";
        }, 300);
      } else {
        setIsLogin(true);
        setLastSignUpTime(Date.now()); // ✅ Store last signup time
      }

      setAttempts(0); // ✅ Reset failed attempts on success
    } else {
      console.error("❌ Authentication failed:", data);
      toast.error(data.error || "Authentication failed.");
      setAttempts((prev) => prev + 1); // ✅ Increase failed attempt count
    }
  } catch (error) {
    console.error("⚠️ Network error:", error);
    toast.error("Network error. Please check your connection and try again.");
    setAttempts((prev) => prev + 1); // ✅ Increase failed attempt count
  }
};




  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const SocialIcon = ({ Icon, index }) => (
    <div className="social-insight-social-icon-wrapper" ref={(el) => (socialIconsRef.current[index] = el)}>
      <Icon className="social-insight-social-icon" />
    </div>
  );

  return (
    <div className="social-insight-container">
      <canvas ref={canvasRef} className="social-insight-background-canvas" />
      <div className="social-insight-floating-elements">
        <div className="social-insight-floating-element">
          <div className="social-insight-social-icon-wrapper" ref={(el) => (socialIconsRef.current[0] = el)}>
            <XIcon />
          </div>
        </div>
        <div className="social-insight-floating-element">
          <SocialIcon Icon={FaFacebookF} index={1} />
        </div>
        <div className="social-insight-floating-element">
          <SocialIcon Icon={FaTiktok} index={2} />
        </div>
        <div className="social-insight-floating-element">
          <SocialIcon Icon={FaInstagram} index={3} />
        </div>
      </div>

      <div className="social-insight-cyber-container">
        <div className="social-insight-form-container">
          <div className="social-insight-form-header">
            <div className="social-insight-logo">
              <img src="/icons/logo.png" alt="Logo" className="social-insight-logo-img" />
            </div>
            <h1> SOCIAL INSIGHT</h1>
            <h2 data-text={isLogin ? 'ACCESS IDENTITY' : 'CREATE IDENTITY'}>{isLogin ? 'ACCESS IDENTITY' : 'CREATE IDENTITY'}</h2>
            <div className="social-insight-cyber-line"></div>
          </div>

          <form onSubmit={handleSubmit}>
          <div className="social-insight-input-group">
            <input
              type="text"
              name="username" // ✅ Changed from "email" to "username"
              placeholder="Username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>

            <div className="social-insight-input-group">
              <div className="social-insight-password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className="social-insight-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex="-1"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            {!isLogin && (
              <div className="social-insight-input-group">
                <div className="social-insight-password-input-wrapper">
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                  <button
                    type="button"
                    className="social-insight-password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    tabIndex="-1"
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>
            )}

<button type="submit" className="social-insight-cyber-button" disabled={isLocked}>
  {isLogin ? 'Login' : 'Sign Up'}
</button>

          </form>

          <p className="social-insight-switch-text">
            {isLogin ? "Don't have an account? " : 'Already have an account? '}
            <span onClick={() => setIsLogin(!isLogin)} className="social-insight-switch-link">
              {isLogin ? 'Sign Up' : 'Login'}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
